(() => {
  const TAG = 'business-hub-office-essentials';

  if (customElements.get(TAG)) return;

  class BusinessHubOfficeEssentials extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.tabs = Array.from(this.querySelectorAll('[data-oe-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-oe-panel]'));

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      const ready = () => {
        // Pre-init every panel while they still have layout width.
        this.panels.forEach((panel) => this._initPanel(panel));

        const activeTab =
          this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
        if (activeTab) this._activate(activeTab);
      };

      if (window.customElements && customElements.get('slider-component')) {
        requestAnimationFrame(ready);
      } else if (window.customElements) {
        customElements.whenDefined('slider-component').then(() => requestAnimationFrame(ready));
      } else {
        requestAnimationFrame(ready);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      const tab = e.target.closest('[data-oe-tab]');
      if (!tab || !this.contains(tab)) return;
      this._activate(tab);
    }

    _activate(tab) {
      const id = tab.getAttribute('data-oe-tab');

      this.tabs.forEach((item) => {
        const on = item.getAttribute('data-oe-tab') === id;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      let target = null;
      this.panels.forEach((panel) => {
        const on = panel.getAttribute('data-oe-panel') === id;
        panel.hidden = !on;
        if (on) target = panel;
      });

      if (!target) return;

      requestAnimationFrame(() => {
        this._initPanel(target);
        this._refreshPanel(target);
      });
    }

    _initPanel(panel) {
      if (panel.dataset.oeInit === 'true') return;

      const slider = panel.querySelector('slider-component');
      if (!slider) {
        panel.dataset.oeInit = 'true';
        return;
      }

      if (typeof slider.init !== 'function') return;

      const list = panel.querySelector('.slider-list');
      if (list && list.offsetWidth === 0) {
        window.setTimeout(() => this._initPanel(panel), 50);
        return;
      }

      const instance = slider.init();
      if (instance) {
        panel.dataset.oeInit = 'true';
        this._requestCardHeightSync(panel);
      }
    }

    _refreshPanel(panel) {
      const slider = panel.querySelector('slider-component');
      if (!slider || !slider.slider) {
        this._requestCardHeightSync(panel);
        return;
      }

      try {
        if (typeof slider.slider.refresh === 'function') {
          slider.slider.refresh();
        }
      } catch (error) {
        console.warn(error);
      }

      this._requestCardHeightSync(panel);
    }

    _requestCardHeightSync(panel) {
      const section = panel.closest('.business-hub-office-essentials-section');
      if (!section) return;

      requestAnimationFrame(() => {
        document.dispatchEvent(
          new CustomEvent('product-card-carousel:resync', {
            detail: { section, panel },
          })
        );
      });
    }
  }

  customElements.define(TAG, BusinessHubOfficeEssentials);
})();
